// viewport.service.ts
import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ResponsiveViewService {
  showDemoFeature: boolean = false; // Flag to control demo feature visibility
  private isMobileViewSubject = new BehaviorSubject<boolean>(false);
  isMobileView$: Observable<boolean> = this.isMobileViewSubject.asObservable();

  constructor(private readonly breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Handset
    ]).subscribe(result => {
      const isMobile = result.matches || this.isMobileDevice();
      this.isMobileViewSubject.next(isMobile);
    });
  }

  private isMobileDevice(): boolean {
    return /iPhone|Android|webOS|BlackBerry|IEMobile/i.test(navigator.userAgent);
  }
}
